<template>
  <div class="d-flex flex-column justify-content-start col-lg-3 acknowledgement-wrap">
    <div v-if="!claim.acknowledgement_sent" class="acknowledgement-not-sent">
      <div class="d-flex">
        <span class="ack-message">
          <i class="fa fa-exclamation-triangle ack-icon-warning" />
          Acknowledgement email has not been sent yet.
        </span>
      </div>
      <!--      <div class="d-flex justify-content-end align-items-center" @click="toggleSidebar">-->
      <!--        <i class="fa fa-paper-plane ack-icon-warning pr-2" />-->
      <!--        <span class="send-ack-email">-->
      <!--          Send email-->
      <!--        </span>-->
      <!--      </div>-->
    </div>
    <div v-else-if="claim.acknowledgement_sent && !mailSentAmountEntered" class="acknowledgement-sent">
      <div class="d-flex">
        <span class="ack-message">
          <i class="fa fa-envelope ack-icon" />
          Acknowledgement email has been sent.
        </span>
      </div>
      <div class="d-flex justify-content-end align-items-center">
        <span
          @click="view($event, claim.id)"
          class="go-to-claim"
        >
          Go to claim
        </span>
      </div>
    </div>
    <div v-else-if="mailSentAmountEntered && !claim.settlement_email_sent" class="gray-box">
      <div class="d-flex mb-2">
        <span class="settlement-amount">
          Settlement amount
        </span>
      </div>
      <div v-if="claim.settlement_amounts.length" class="d-flex justify-content-between align-items-center">
        <div class="d-flex flex-column">
          <span class="settlement-amount-name">
            Office
            <i class="fa" :class="[claim.settlement_amounts[0].settlement_status.name === 'Approved' ?
              'fa-check-circle approved-icon' :
              (claim.settlement_amounts[0].settlement_status.name === 'Declined' ? 'fa-times-circle denied-icon' : '')]"
            />
          </span>
          <span>
            ${{ claim.settlement_amounts[0].amount }}
          </span>
        </div>
        <div class="d-flex flex-column">
          <span class="settlement-amount-name">
            Subco
            <i class="fa" :class="[claim.settlement_amounts[1].settlement_status.name === 'Approved' ?
              'fa-check-circle approved-icon' :
              (claim.settlement_amounts[1].settlement_status.name === 'Declined' ? 'fa-times-circle denied-icon' : '')]"
            />
          </span>
          <span>
            ${{ claim.settlement_amounts[1].amount }}
          </span>
        </div>
        <div class="d-flex flex-column">
          <span class="settlement-amount-name">
            Total approved
          </span>
          <span>
            ${{ claim.settlement_amount }}
          </span>
        </div>
      </div>
    </div>
    <div v-else-if="mailSentAmountEntered && claim.settlement_email_sent"
         class="gray-box"
         :class="[{ 'green-border': claim.settlement_customer_approved },
                  { 'red-border': !claim.settlement_customer_approved },
                  { 'no-border' : !claim.hasOwnProperty('settlement_customer_approved') }]"
    >
      <div class="d-flex mb-2">
        <span class="settlement-amount">
          Settlement amount
        </span>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <span class="settlement-amount-sent"
              :class="[{ 'green-text': claim.settlement_customer_approved },
                       { 'red-text': !claim.settlement_customer_approved },
                       { 'no-color' : !claim.hasOwnProperty('settlement_customer_approved') }]"
        >
          <span v-if="!claim.hasOwnProperty('settlement_customer_approved')">
            <strong>${{ claim.settlement_amount }}</strong> settlement offer emailed to the customer.
          </span>
          <span v-else-if="claim.settlement_customer_approved">
            Customer accepted settlement amount of<strong> ${{ claim.settlement_amount }}</strong>
          </span>
          <span v-else-if="!claim.settlement_customer_approved">
            Customer declined settlement amount of<strong> ${{ claim.settlement_amount }}</strong>
          </span>
        </span>
      </div>
    </div>

    <!-- Claim email -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showEmailModal">
        <send-claim-email
          class="sidebar-right"
          :list="true"
          :job="claim"
          :type-id="2"
          @update="$emit('update')"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import SendClaimEmail from './Modals/SendClaimEmail';

export default {
  components: {
    SendClaimEmail,
  },
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    showEmailModal: false,
  }),
  computed: {
    mailSentAmountEntered() {
      return this.claim.acknowledgement_sent && this.claim.settlement_amounts.length >= 1;
    },
  },
  methods: {
    // toggleSidebar() {
    //   this.showEmailModal = !this.showEmailModal;
    // },
    view(event, id) {
      this.$router.push(`/claims/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q)}` : ''}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/claims/ClaimsBlockSettlementAmount.vue